<template>
	<div
		class="
			col-span-2 shadow-xs bg-background-secondary rounded-2.5xl overflow-hidden grid
			sm:grid-cols-[70%_30%]
			md:grid-cols-[1fr_170px]
			lg:grid-cols-[1fr_245px]
			lg:rem:min-h-[300px]
		"
		:class="{'md:col-auto': !large}"
	>
		<div
			class="
				p-4
				pt-4
				sm:pr-0
				md:p-6
				md:pr-0
				lg:p-8
				lg:pr-0
				lg:pt-12
				grow
				flex
				flex-col
				justify-between
				items-start
			"
		>
			<div
				class="mr-10"
				:class="{
					'w-full': fullWidth,
				}"
			>
				<h2 class="typo-h3 text-heading-primary mb-2">
					<slot name="title" />
				</h2>
				<div class="typo-body-m text-body-secondary [&_*]:!text-body-secondary">
					<slot name="text" />
				</div>
				<slot name="cta" />
			</div>
		</div>
		<div v-if="$slots.img" class="relative max-sm:hidden [&>*]:absolute [&>*]:inset-0" aria-hidden="true">
			<slot name="img" />
		</div>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		large?: boolean
		fullWidth?: boolean
	}

	defineProps<Props>();
</script>
